import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { styled } from "@mui/system";


const StyledDatePicker = styled(MuiDatePicker)(({ theme }) => ({
  width: '100%',

  "& .MuiFormLabel-root.MuiInputLabel-root": {
    color: theme.palette.text.primary,
  },

  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: '4px',
  },

  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":{
    borderColor: theme.palette.primary.light,
    borderWidth: 1,
  },

  "& .Mui-error": {
    borderColor: theme.palette.error.main,
    backgroundColor: theme.palette.primary.main,

    "&.MuiFormHelperText-root": {
      background: "none",
    },
  },
}));

export default StyledDatePicker;
